import React, { useEffect, useState } from "react";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import { formatDateTime, mergeParams } from "../../helpers/helpers";
import Form from "../../components/form";

export default function Lista({ history, location }) {
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        codigo: "",
        titulo: "",
        responsavelUsuarioId: 0,
      },
      location
    )
  );

  const [chamados, setChamados] = useState([]);
  const [responsaveis, setResponsaveis] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    carregarUsuarios();
    carregarChamados();
  }, []);

  const carregarUsuarios = () => {
    api
      .get("grupos/membros", { grupoCodIdentificador: "ADMIN_SISTEMA" })
      .then((res) => {
        setResponsaveis(res);
      });
  };

  const carregarChamados = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    setCarregando(true);
    api.get("chamados/listar", filtrosEnviar).then((res) => {
      res.forEach((r) => {
        if (r.situacao === 1) r.situacaoNome = "Aberto";
        if (r.situacao === 2) r.situacaoNome = "Concluído";
        if (r.situacao === 3) r.situacaoNome = "Cancelado";
        r.criadoEm = formatDateTime(r.criacao, "D/M/Y h:m");
        r.responsavel = r.responsavelUsuarioNome
          ? r.responsavelUsuarioNome
          : "(não informado)";
      });
      setChamados(res);
      setCarregando(false);
    });
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      codigo: {
        label: "Código",
        type: "text",
        space: 4,
        value: filtros.codigo,
      },
      titulo: {
        label: "Título",
        type: "text",
        space: 4,
        value: filtros.titulo,
      },
      responsavelUsuarioId: {
        label: "Responsável",
        space: 4,
        value: filtros.responsavelUsuarioId,
        type: "select",
        emptyItem: true,
        array: {
          data: responsaveis,
          value: "usuarioId",
          desc: "usuarioNome",
        },
      },
      legenda: {
        type: 'component',
        value: <p>Para consultar solicitações concluídas ou canceladas, filtrar por código ou responsável.</p>
      }
    },

    submit: {
      label: "Buscar",
      action: carregarChamados,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirDados = (registro) => {
    history.push(`/app/chamados/item/${registro.id}`);
  };

  const tRegistros = {
    title: "Solicitações",
    onLineClick: abrirDados,
    newItemAction: () => history.push("/app/novo-chamado"),
    columns: [
      {
        label: "Código",
        name: "id",
      },
      {
        label: "Aberto em",
        name: "criadoEm",
      },
      {
        label: "Título",
        name: "titulo",
      },
      {
        label: "Criado por",
        name: "usuarioNome",
      },
      {
        label: "Situação",
        name: "situacaoNome",
      },
      {
        label: "Responsável",
        name: "responsavel",
      },
    ],
    array: chamados,
  };

  return (
    <div>
      <Form formData={fFiltros} />

      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
